import { render, staticRenderFns } from "./AgencyMessageLeftSection.vue?vue&type=template&id=34fa1eaf&scoped=true"
import script from "./AgencyMessageLeftSection.vue?vue&type=script&lang=js"
export * from "./AgencyMessageLeftSection.vue?vue&type=script&lang=js"
import style0 from "./AgencyMessageLeftSection.vue?vue&type=style&index=0&id=34fa1eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa1eaf",
  null
  
)

export default component.exports